//Funcao para pegar api do VIACEP retornando um JSON.
export default {
    showCep(cep) {
        let search = cep.replace("-","")
        const options = {
            method: 'GET',
            mode: 'cors',
            cache: 'default'
        }
        if (search.length < 8) {
            return
        }
        return fetch(`https://viacep.com.br/ws/${search}/json/`, options)
    }
}